import React from 'react';
import { Form, Input, InputNumber, Typography, Switch, Row, Col } from 'antd';

const { Text } = Typography;

const SliceNodeProperties = ({ config }) => {
  return (
    <>
      <Form.Item label="Start Index" name="startIndex" initialValue={config.startIndex || 0}>
        <InputNumber 
          min={0} 
          placeholder="Starting row number (0-based)" 
          style={{ width: '100%' }}
        />
      </Form.Item>
      
      <Form.Item label="Limit" name="limit" initialValue={config.limit || 100}>
        <InputNumber 
          min={1} 
          placeholder="Maximum number of rows to return" 
          style={{ width: '100%' }}
        />
      </Form.Item>

      <Row gutter={12}>
        <Col span={12}>
          <Form.Item label="Skip Rows" name="skipRows" initialValue={config.skipRows || 0}>
            <InputNumber 
              min={0} 
              placeholder="Rows to skip" 
              style={{ width: '100%' }}
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label="Use End Index" name="useEndIndex" initialValue={config.useEndIndex || false} valuePropName="checked">
            <Switch />
          </Form.Item>
        </Col>
      </Row>

      {config.useEndIndex && (
        <Form.Item label="End Index" name="endIndex" initialValue={config.endIndex || 100}>
          <InputNumber 
            min={1} 
            placeholder="Ending row number (exclusive)" 
            style={{ width: '100%' }}
          />
        </Form.Item>
      )}

      <Form.Item label="Description" name="description" initialValue={config.description || ''}>
        <Input placeholder="Describe the data slicing operation" />
      </Form.Item>

      <div style={{ padding: '8px 12px', backgroundColor: '#f9f9f9', borderRadius: '4px', fontSize: '12px', marginTop: '12px' }}>
        <Text type="secondary">
          <strong>Slice/Limit Node:</strong><br/>
          • Extracts subset of rows from dataset<br/>
          • Start Index: First row to include (0-based)<br/>
          • Limit: Maximum rows to return<br/>
          • Useful for pagination or sampling data
        </Text>
      </div>
    </>
  );
};

export default SliceNodeProperties;